// MobileNav.js
import React from 'react'
import { Home, Heart, LayoutGrid, Settings } from 'lucide-react'
import { NavLink } from 'react-router-dom'

export default function MobileNav() {
  const navItems = [
    { path: '/dashboard/home', icon: <Home />, label: 'Home' },
    { path: '/dashboard/categories', icon: <LayoutGrid />, label: 'Categories' },
    { path: '/dashboard/favorites', icon: <Heart />, label: 'Favorites' },
    { path: '/dashboard/settings', icon: <Settings />, label: 'Settings' },
  ];

  return (
    <nav className="mobile-nav">
      {navItems.map((item, index) => (
        <NavLink
          key={index}
          to={item.path}
          className={({ isActive }) =>
            isActive ? 'nav-item active' : 'nav-item'
          }
        >
          {item.icon}
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
